import { useI18n } from '../context/I18nContext';

export default function LanguageSwitcher({ className = '', labelClassName = '', selectClassName = '', compact = false, theme = 'light' }) {
    const { language, options, setLanguage, t } = useI18n();
    const isDarkTheme = theme === 'dark';
    const resolvedLabelClassName = labelClassName || (isDarkTheme ? 'text-gray-300' : 'text-gray-600');
    const resolvedSelectClassName = isDarkTheme
        ? 'border-gray-700 bg-gray-800 text-gray-100 shadow-black/20'
        : 'border-gray-300 bg-white text-gray-700 shadow-sm';

    return (
        <label className={`flex items-center gap-2 text-sm ${resolvedLabelClassName} ${className}`}>
            {!compact && <span>{t('common.language.label')}</span>}
            <select
                value={language}
                onChange={(event) => setLanguage(event.target.value)}
                aria-label={t('common.language.label')}
                style={{ colorScheme: isDarkTheme ? 'dark' : 'light' }}
                className={`rounded-md border px-2 py-1.5 text-sm transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 ${resolvedSelectClassName} ${selectClassName}`}
            >
                {options.map((option) => (
                    <option key={option.code} value={option.code}>
                        {option.label} · {option.nativeName}
                    </option>
                ))}
            </select>
        </label>
    );
}